<template>
  <div>
    <v-alert
      v-if="ShowErrorMessage && !mandatoryFieldCompiled"
      color="red darken-4"
      dark
      icon="mdi-alert-octagon-outline"
      dense
    >
      Seleziona un cliente
    </v-alert>
    <v-row>
      <v-col cols="10">
        <v-combobox
          v-model="idCliente"
          label="Cliente"
          outlined
          :items="clients"
          item-text="descrizione"
        >
        </v-combobox>
      </v-col>

      <v-col cols="2">
        <v-btn
          color="smokewhite"
          class="addCliente"
          @click.stop="btnAddCustomer_Click"
        >
          <v-icon dark> mdi-plus </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="10">
        <v-select
          v-model="idSede"
          label="Sede"
          outlined
          :items="sedi"
          item-text="fullAddress"
          item-value="idSede"
          v-on:change="cmbSede_Changed"
        >
        </v-select>
      </v-col>

      <v-col cols="2">
        <v-btn
          color="smokewhite"
          class="addCliente"
          v-bind:disabled="eventInfo.idCliente == undefined"
          @click.stop="btnAddHeadquarter_Click"
        >
          <v-icon dark> mdi-plus </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" v-if="showMap">
        <Map
          v-bind:indirizzo="this.sede.indirizzo"
          v-bind:citta="this.sede.citta"
        ></Map>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <FrmEditCustomer
          ref="frmCustomer"
          v-bind:clientInfo="this.clientInfo"
          v-bind:eventInfo="this.eventInfo"
          v-on:close-dialog="closeDialog"
          v-on:customerAdded="customer_Added"
        ></FrmEditCustomer>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="frmEditCustomerSave_Click">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogHeadquarter" persistent max-width="600px">
      <v-card>
        <FrmEditHeadquarter
          ref="frmEditHeadquarter"
          v-bind:headquarterDetails="headquarterDetails"
          v-on:headquarterAdded="headquarter_Added"
        ></FrmEditHeadquarter>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogHeadquarter = false">
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="frmEditHeadqurterSave_Click"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EasyPlanClient from "../../../utils/EasyPlanClient";
import FrmEditCustomer from "../../EditForms/FrmEditCustomer";
import FrmEditHeadquarter from "../../EditForms/FrmEditHeadquarter";
import Map from "../../CustomComponentsUI/Map";
export default {
  components: { FrmEditCustomer, FrmEditHeadquarter, Map },
  props: ["eventInfo"],

  watch: {
    eventInfo: function (val) {
      console.log("prop changed");
      console.log(val);
      this.idSede = val.idSede;
      if (val.idCliente != undefined && val.idCliente != null) {
        this.loadHeadquarters(val.idCliente);
      }
    },
    idSede(val) {
      this.eventInfo.idSede = val;
    },
  },
  data: () => ({
    error: null,
    name: "",
    Info: null,
    disabled: false,
    ShowErrorMessage: false,
    dialog: false,
    idSede: 0,
    dialogHeadquarter: false,
    row: 0,
    sedeObj: undefined,
    sedi: [],
    clients: [],
    headquarterDetails: {
      indirizzo: "",
      cap: "",
      citta: "",
      provincia: "",
    },

    clientInfo: {
      descrizione: "",
      indirizzo: "",
      cap: "",
      città: "",
      provincia: "",
      telefono: "",
      mail: "",
      sedi: [],
    },
  }),
  mounted() {
    console.log(this.eventInfo);
    this.loadHeadquarters(this.eventInfo.idCliente);
    this.idSede = this.eventInfo.idSede;
    // eventInfo:this.eventInfo,
  },
  created() {
    this.initialize();
  },
  computed: {
    mandatoryFieldCompiled: {
      get() {
        return Boolean(this.eventInfo.idCliente>0);
      },
    },
    idCliente: {
      get() {
        return this.clients.find(c=>c.idCliente==this.eventInfo.idCliente) ;
      },
      set(val) {
        this.eventInfo.idCliente = val.idCliente;
        var cmpnt = this;
        this.loadHeadquarters(val.idCliente, (sedi) => {
          cmpnt.clientInfo = cmpnt.clients.find((c) => c.idCliente == val.idCliente);
          this.eventInfo.cliente=cmpnt.clientInfo;
          cmpnt.idSede = cmpnt.clientInfo.idSedePrincipale;
        });
      },
    },
    sede: {
      get() {
        console.debug(this.idSede);
        return this.sedi.find((s) => s.idSede == this.idSede);
      },
    },

    showMap() {
      return this.sede != undefined;
    },
  },

  methods: {
    isEmptyOrSpaces: function (str) {
      return str === null || str.match(/^ *$/) !== null;
    },
    CanGoFarward() {
      this.ShowErrorMessage = true;
      return this.mandatoryFieldCompiled; // > 0;
    },
    btnAddCustomer_Click() {
      this.clientInfo = {
        descrizione: "",
        indirizzo: "",
        cap: "",
        città: "",
        provincia: "",
        telefono: "",
        mail: "",
        sedi: [],
      };
      this.dialog = true;
    },
    btnAddHeadquarter_Click() {
      this.headquarterDetails = {
        indirizzo: "",
        cap: "",
        citta: "",
        provincia: "",
      };
      this.dialogHeadquarter = true;
    },
    cmbSede_Changed() {
      // this.sedeObj=this.sede;
      //  this.sede=this.sedi.find((s)=>s.idSede==this.eventInfo.idSede)
    },
    frmEditCustomerSave_Click: function () {
      this.$refs.frmCustomer.addClient(() => {
        this.closeDialog();
      });
    },
    customer_Added() {
      // alert("customer added")
      this.loadCustomers();
    },
    headquarter_Added(headquarter) {
      headquarter.fullAddress=this.getFullAddress(headquarter.indirizzo,headquarter.citta,headquarter.provincia);
      console.debug("headquarter",headquarter);
      
      this.sedi.push(headquarter);
      this.idSede = headquarter.idSede;
    },
    frmEditHeadqurterSave_Click: function () {
      this.$refs.frmEditHeadquarter.save(
        this.$route.params.companyAlias,
        this.eventInfo.idCliente
      );
      this.dialogHeadquarter = false;
      // $refs.frmEditHeadquarter.save
    },
    closeDialog: function () {
      this.dialog = false;
    },
    closeHeadquarterDialog: function () {
      this.dialogHeadquarter = false;
    },
    show: function () {
      alert();
    },

    initialize() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        console.debug("logging off");
        localStorage.userToken = null;

        this.$router.push({
          name: "login",
          params: { companyAlias: this.$route.params.companyAlias },
        });
      }
      this.loadCustomers();
    },
  getFullAddress(address, city, province) {
      let fullAddress = ""; //address + " - " + city + " (" + province + ") ";
      if (address != null) fullAddress += address;
      if (city != null) fullAddress += " - " + city;
      if (province != null) fullAddress += " (" + province + ")";

      return fullAddress;
    },
        
    loadCustomers() {
      console.log("loading customers...");
      EasyPlanClient.Customers.GetAll(
        this.$route.params.companyAlias,
        this.eventInfo.idCliente
      )
        .then((res) => { 
          this.clients = res.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    loadHeadquarters(customerId, callback = () => {}) {
      console.log("loading headquarters....");
      EasyPlanClient.Headquarters.GetAll(
        this.$route.params.companyAlias,
        customerId
      )
        .then((res) => {
          this.sedi = res.data.data;
          for(let i=0;i<this.sedi.length;i++){
            let sede= this.sedi[i];
            this.sedi[i].fullAddress=this.getFullAddress(
            sede.indirizzo,
            sede.citta,
            sede.provincia
          );
          }
          callback(this.sedi);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
  },
};
</script>

<style>
.addCliente {
  margin-top: 12px;
}

.addIntervento {
  margin-top: 12px;
}
</style>